module.exports = __webpack_public_path__ + "img/multiplier_5_th.6b373695.png";